export interface MinimalTemplate {
  type: 'minimal';
  text?: null | string;
  iconUrl?: null | string;
}

export interface CardTemplate {
  type: 'card';
  title?: null | string;
  buttons?: null | ButtonTemplate[];
  orientation?: null | CardOrientation;
  icon?: null | string;
  textLines?: null | string[];
  imageUrl?: null | string;
}

export enum CardOrientation {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export interface ButtonTemplate {
  type?: null | ButtonType;
  url?: null | string;
  title?: null | string;
}

export enum ButtonType {
  CTA = 'CTA',
  UNKNOWN_BUTTON_TYPE = 'UNKNOWN_BUTTON_TYPE',
}

// Fixed, non-themeable layout — the button's look (green icon, white/bordered
// chrome) must not vary with the site's button style params, unlike
// CardTemplate/ButtonTemplate's WidgetButton-rendered buttons. Kept as its
// own additionalData variant rather than reusing ButtonTemplate for this.
export interface WhatsAppSocialButtonTemplate {
  type: 'whatsappSocialButton';
  infoText?: null | string;
  url?: null | string;
}

export interface WixUserMedia {
  mimeType?: null | string;
  url?: null | string;
  altText?: null | string;
  caption?: null | string;
  fileName?: null | string;
  fileSizeInBytes?: null | number;
  lengthInMs?: null | number;
  id?: null | string;
  thumbnailUrl?: null | string;
}
